import { render, staticRenderFns } from "./MedicalRequirementsPlansRays.vue?vue&type=template&id=db4f1d82&"
import script from "./MedicalRequirementsPlansRays.vue?vue&type=script&lang=js&"
export * from "./MedicalRequirementsPlansRays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports